module.exports = __webpack_public_path__ + "fonts/light.4feb1dcd.woff2";